import * as React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, makeStyles } from '@material-ui/core';
import { useIifImportSelector, IifImportSelectors } from '../store/modules/iifImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import SalesItemDistributionView from './SalesItemDistributionView';
import { useApplicationSettingsSelector, ApplicationSettingsSelectors, TaxMode } from '../store/modules/applicationSettings';
import AudCurrencyFormatter from '../utilities/currencyFormatter';

interface ISalesItemDistributionViewsProps {
    distributionView: number[];
    amount: number;
    tax: number;
    total: number;
}

const useStyles = makeStyles(theme => ({
    expandCell: {
        width: 75
    },
    indexCell: {
        width: 75
    },
    descriptionCell: {
    },
    taxCodeCell: {
        width: 220
    },
    amountCell: {
        width: 150
    },
    totalCell: {
        fontWeight: 'bold'
    },
    totalAmountCell: {
        fontWeight: 'bold'
    },
    hiddenCell: {
        border: 'none'
    }
}))

const SalesItemDistributionViews: React.FunctionComponent<ISalesItemDistributionViewsProps> = ({
    distributionView,
    amount,
    tax,
    total
}) => {
    const classes = useStyles();

    const taxMode = useApplicationSettingsSelector(ApplicationSettingsSelectors.selectTaxMode);

    if (!distributionView) {
        return null;
    }

    return (
        <Table aria-label="spanning table" size="small">
            <TableHead>
                <TableRow>
                    <TableCell className={classes.expandCell} />
                    <TableCell className={classes.indexCell}>#</TableCell>
                    <TableCell>Account</TableCell>
                    <TableCell>Class</TableCell>
                    <TableCell>Item</TableCell>
                    <TableCell className={classes.descriptionCell}>Description</TableCell>
                    <TableCell className={classes.taxCodeCell}>Tax Code</TableCell>
                    <TableCell className={classes.amountCell} align="right">Amount</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    distributionView?.map((distributionIndex, index) => {
                        return (
                            <SalesItemDistributionView
                                key={distributionIndex}
                                distributionIndex={distributionIndex}
                                distributionPosition={index + 1}
                            />
                        );
                    })
                }
                {
                    taxMode === TaxMode.Excluded && (
                        <>
                            <TableRow>
                                <TableCell className={classes.hiddenCell} colSpan={6} />
                                <TableCell className={classes.totalCell}>SUBTOTAL</TableCell>
                                <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(amount)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.hiddenCell} colSpan={6} />
                                <TableCell className={classes.totalCell}>TAX</TableCell>
                                <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(tax)}</TableCell>
                            </TableRow>
                        </>
                    )
                }
                <TableRow>
                    <TableCell className={classes.hiddenCell} colSpan={6} />
                    <TableCell className={classes.totalCell}>TOTAL</TableCell>
                    <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(total)}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}

export default SalesItemDistributionViews;


// WEBPACK FOOTER //
// ./src/components/SalesItemDistributionsView.tsx